import * as bootstrap from 'bootstrap';
import $ from 'jquery';

import Config from '../Config';

import { compareVersions } from './utils';
import { getFirmwareTarget } from './FirmwareModal';

let LISTENER = () => {};
const SINGLE_QUOTE = '-*-*-';

const location = new URL(window.location);
const client = location.hostname.split('.', 3);
let prefix = 'dev';

if (client.indexOf('localhost') === -1 && client.indexOf('dev') === -1) {
  prefix = 'prod';
}

function command(row, username) {
  $('body').append(getDialogHTML(row, username));

  const commandModal = new bootstrap.Modal('#commandmodal');
  const modalElement = document.getElementById('commandmodal');
  const interval = (row.screenshotinterval || Config.SCREENSHOT_INTERVAL) / 1000;

  function dispose() {
    commandModal.dispose();
    $('#commandmodal').remove();
  }

  modalElement.addEventListener('hidden.bs.modal', dispose);

  $('input[name="command"]').on('click', () => {
    const command = $('input[name="command"]:checked').val();

    if (command === 'screenshot') {
      $('#screenshotinterval').prop('disabled', false).prop('readonly', false);
    } else {
      $('#screenshotinterval').val(interval);
      $('#screenshotinterval').prop('disabled', true).prop('readonly', true);
    }

    if (command === 'vistar-enable') {
      $('#vistarfrequency-group').removeClass('d-none');
      $('#vistarfrequency').prop('disabled', false);
    } else {
      $('#vistarfrequency-group').addClass('d-none');
      $('#vistarfrequency').prop('disabled', true);
    }
  });

  $('#commandmodal #sendcommand').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    $('.invalid-feedback').hide();

    const form = $('.needs-validation')[0];
    const rowData = JSON.parse($('input[name="rowdata"]').val().replaceAll(SINGLE_QUOTE, "'"));
    let command = $('input[name="command"]:checked').val();

    if (!form.checkValidity()) {
      if (!command) {
        $('.invalid-command').show();
      } else if (command === 'import') {
        $('.invalid-tllfile').show();
      } else {
        $('.invalid-interval').show();
      }
      return;
    }

    const finalizeAndSend = () => {
      command = command.toUpperCase();
      LISTENER({ command, rowData });
      commandModal.hide();
    };

    if (command === 'screenshot') {
      const interval = parseInt($('#screenshotinterval').val());
      rowData.screenshotinterval = (interval * 1000).toString();
      finalizeAndSend();
    } else if (command === 'import') {
      const fileInput = document.getElementById('importfile').files[0];
      readFile(fileInput).then(fileContent => {
        postTLL(fileContent).then(fileURL => {
          rowData.payload = fileURL;
          finalizeAndSend();
        });
      });
    } else if (command === 'firmware') {
      rowData.payload = $('input[name="command"]:checked').attr('data-firmware-path');
      finalizeAndSend();
    } else if (command === 'vistar-enable') {
      rowData.vistarEnabled = true;
      rowData.vistarFrequency = parseInt($('#vistarfrequency').val()) || 60;
      command = 'vistar';
      finalizeAndSend();
    } else if (command === 'vistar-disable') {
      rowData.vistarEnabled = false;
      rowData.vistarFrequency = 0;
      command = 'vistar';
      finalizeAndSend();
    } else {
      finalizeAndSend();
    }
  });

  $('input[type="radio"]').on('change', e => {
    const importfile = $('#importfile');

    if (e.target.value === 'import') {
      importfile.prop('disabled', false);
      importfile.prop('readonly', false);
      importfile.prop('required', true);
      importfile.removeClass('d-none');
    } else {
      importfile.prop('disabled', true);
      importfile.prop('readonly', true);
      importfile.prop('required', false);
      importfile.addClass('d-none');
      importfile.val('');
    }
  });

  commandModal.show();
}

function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      const xmlString = e.target.result;
      resolve(xmlString);
    };

    reader.onerror = function (err) {
      reject(`File read error ${err}`);
    };

    reader.readAsText(file);
  });
}

async function postTLL(data) {
  return new Promise((resolve, reject) => {
    const TLL_URL = `https://img.support.${prefix}.ab-net.us/tllsave`;
    const deviceData = JSON.parse($('input[name="rowdata"]').val());
    const client = deviceData.client;
    const macAddress = deviceData.macAddress;
    const url = `${TLL_URL}?file=${client}.${macAddress}.TLL`;

    $.ajax({
      url,
      type: 'POST',
      contentType: 'application/xml',
      data,
      processData: false,
      success(response) {
        resolve(response.url);
      },
      error(xhr, status, error) {
        reject('Error uploading TLL file:', error);
      },
    });
  });
}

function setListener(listener) {
  if (typeof listener === 'function') {
    LISTENER = listener;
  }
}

function getDialogHTML(row, username) {
  const interval = (row.screenshotinterval || Config.SCREENSHOT_INTERVAL) / 1000;
  let type = 'Device';
  let name = row.device_name;
  let s = '';
  const tllCommands = false;
  let popLogging = false;
  let enableDisableText = 'Enable';
  const showVistar = row.vistar && !row.wall.length;

  const date = new Date(row.lastreboot);
  const lastreboot = date.toLocaleString();
  const foundUser = Config.findUserLogin(username);

  if (row.wall.length) {
    type = 'Display';
    name = row.display_name;
    s = 's';
  }

  // pop logging added in version 3.3.0
  if (row.serverversion && compareVersions(row.serverversion, '3.2.20') > 0) {
    popLogging = true;
    console.log(row);
    if (row.poplog === '1') {
      enableDisableText = 'Disable';
    }
  }

  let html = `
    <div class="modal fade" id="commandmodal" tabindex="-1" aria-labelledby="commandmodallabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="needs-validation" novalidate>
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="commandmodallabel">${type} Command</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Send command to ${type}: <span class="bold">${name}</span> on: "${row.client}"</p>
                    <input type="hidden" name="rowdata" value='${JSON.stringify(row).replaceAll("'", SINGLE_QUOTE)}' />
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="command" id="commandreboot" value="reboot" required />
                        <label class="form-check-label" for="commandreboot">
                            <span class="bold">Reboot ${type}</span> <span class="small">last reboot: ${lastreboot}</span>
                        </label>
                    </div>`;
  if (!foundUser) {
    html += `
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="command" id="commandrestart" value="restart" />
                                <label class="form-check-label" for="commandrestart">
                                    <span class="bold">Restart App${s}</span>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="command" id="commandupdate" value="unzip" />
                                <label class="form-check-label" for="commandupdate">
                                    <span class="bold">Update App${s}</span>
                                </label>
                            </div>
                            <div class="form-check form-check form-check-inline">
                                <input class="form-check-input mt-1" type="radio" name="command" id="commandscreenshot" value="screenshot" />
                                <label class="form-check-label" for="commandscreenshot">
                                    <span class="bold">Screenshot Interval</span>
                                </label>
                                <div class="invalid-feedback invalid-interval">
                                    Interval must be:
                                </div>
                            </div>
                            <div class="form-check form-check form-check-inline interval">
                                <input type="number" class="form-check-label small" id="screenshotinterval" min="10" max="300" value="${interval}" readonly disabled required>
                                <label class="form-check-label" for="screenshotinterval">
                                    <span class="small">Seconds for 5 minutes</span>
                                </label>
                                <div class="invalid-feedback invalid-interval">
                                    10 - 300
                                </div>
                            </div>`;
    if (tllCommands) {
      html += `
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandexport" value="export" />
                                        <label class="form-check-label" for="commandexport">
                                            <span class="bold">Export Device${s} Settings</span>
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandimport" value="import" />
                                        <label class="form-check-label" for="commandimport">
                                            <span class="bold">Import Device${s} Settings</span>
                                        </label>
                                        <input class="form-control form-control-sm mt-1 d-none" id="importfile" type="file" accept=".tll,.xml" readonly disabled>
                                        <div class="invalid-feedback invalid-tllfile">
                                            .TLL file required
                                        </div>
                                    </div>`;
    }
    if (popLogging) {
      html += `
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandpoplog" value="poplog" />
                                        <label class="form-check-label" for="commandpoplog">
                                            <span class="bold">${enableDisableText} Proof of Play Logging</span>
                                        </label>
                                    </div>`;
    }
    if (showVistar) {
      const vistarIsEnabled = row.vistarEnabled === '1';
      const vistarCurrentFrequency = parseInt(row.vistarFrequency) || 60;
      const freqMinutes = prefix === 'dev' ? [1, 3, 5, 10, 15, 30, 60] : [3, 5, 10, 15, 30, 60];
      const freqOptionsHtml = freqMinutes
        .map(min => `<option value="${min}"${min === vistarCurrentFrequency ? ' selected' : ''}>${min} min</option>`)
        .join('\n                                            ');
      html += `
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandvistarenable" value="vistar-enable" />
                                        <label class="form-check-label" for="commandvistarenable">
                                            <span class="bold">${vistarIsEnabled ? 'Vistar Ad Interval' : 'Enable Vistar Ads'}</span>
                                        </label>
                                    </div>
                                    <div class="d-none ms-3 mb-1" id="vistarfrequency-group">
                                        <label class="form-label small me-1 mb-0" for="vistarfrequency">Check for ads every</label>
                                        <select id="vistarfrequency" class="form-select form-select-sm d-inline-block w-auto" disabled>
                                            ${freqOptionsHtml}
                                        </select>
                                    </div>`;
      if (vistarIsEnabled) {
        html += `
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandvistardisable" value="vistar-disable" />
                                        <label class="form-check-label" for="commandvistardisable">
                                            <span class="bold">Disable Vistar Ads</span>
                                        </label>
                                    </div>`;
      }
    }

    // Firmware: video wall SM5KE displays only. All screens must be on the same version
    // so one EPK covers all. getFirmwareTarget() decides upgrade vs downgrade.
    if (row.wall && row.wall.length) {
      const allDevices = [row, ...row.wall];
      const allCompatibleModels = allDevices.every(d =>
        /SH7E|SM5KE|UH5[EF]|UH5PE|UM3[EF]|WP40[012]/i.test(d.model || '')
      );
      const allSupportFirmware = allDevices.every(d => compareVersions(d.serverversion || '0.0.0', '4.0.2') >= 0);
      const minVersion = allDevices
        .map(d => d.firmwareVersion || '0.0.0')
        .reduce((a, b) => (compareVersions(a, b) <= 0 ? a : b));
      const target = allCompatibleModels && allSupportFirmware ? getFirmwareTarget(minVersion) : null;

      if (target) {
        const screenCount = allDevices.length;
        const action = compareVersions(minVersion, target.version) < 0 ? 'Upgrade' : 'Downgrade';
        html += `
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="command" id="commandfirmware" value="firmware" data-firmware-path="${target.path}" />
                                        <label class="form-check-label" for="commandfirmware">
                                            <span class="bold">${action} Firmware</span>
                                            <span class="small text-muted"> — all ${screenCount} screen${screenCount !== 1 ? 's' : ''} → ${target.version} (display will reboot)</span>
                                        </label>
                                    </div>`;
      }
    }
    html += `
                                <div class="form-check">
                                    <div class="invalid-feedback invalid-command">
                                        Select a command
                                    </div>
                                </div>`;
  }
  html += `
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button id="sendcommand" type="submit" class="btn btn-primary">Send Command</button>
                        </div>
                    </form>
                </div>
            </div>
            </div>`;

  return html;
}

const modalInterface = {
  command,
  setListener,
};

export default modalInterface;
